import {scoreMenus} from "@/core/config";
import Vue from "vue";
import {mapActions} from "vuex";

const GeneralMixin = {
    data() {
        return {}
    },
    methods: {
        // ...mapActions([
        //     "GET_USER_PERMISSIONS",
        // ]),
        checkIsAccessible(menu, subMenu = '') {
            let user = this.getCurrentUser();
            // let permissions = this.$store.getters.getPermissions;
            if (user.is_kiosk) {
                return true;
            } else
                return false;

        },

        getCurrentUser() {
            return this.$store.getters.currentUser;
        }
    }
};

export default {
    install(Vue, options) {
        Vue.mixin(GeneralMixin)
    }
}


